module.exports = __webpack_public_path__ + "static/media/1.4ec9dc5a.png";